// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.wallet.shared

import org.multipaz.cbor.DataItem
import org.multipaz.wallet.shared.CredentialIssuerOpenID4VCI
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap
import org.multipaz.cbor.Tstr
import org.multipaz.wallet.shared.CredentialIssuerSettings
import org.multipaz.wallet.shared.toDataItem
import org.multipaz.wallet.shared.fromDataItem

fun CredentialIssuerOpenID4VCI.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "oL0mg6hU7Xc3l1bUS-fG6YB-Yfqcxam0IDoHaHIn9PI")
val CredentialIssuerOpenID4VCI_cborSchemaId = ByteString(-96, -67, 38, -125, -88, 84, -19, 119, 55, -105, 86, -44, 75, -25, -58, -23, -128, 126, 97, -6, -100, -59, -87, -76, 32, 58, 7, 104, 114, 39, -12, -14)

fun CredentialIssuerOpenID4VCI.toDataItem(): DataItem {
    val builder = CborMap.builder()
    builder.put("type", "OpenID4VCI")
    builder.put("name", Tstr(this.name))
    builder.put("iconUrl", Tstr(this.iconUrl))
    builder.put("url", Tstr(this.url))
    val id = this.id
    if (id != null) {
        builder.put("id", Tstr(id))
    }
    val credentialIssuerSettings = this.credentialIssuerSettings
    if (credentialIssuerSettings != null) {
        builder.put("credentialIssuerSettings", credentialIssuerSettings.toDataItem())
    }
    return builder.end().build()
}

fun CredentialIssuerOpenID4VCI_fromDataItem(dataItem: DataItem): CredentialIssuerOpenID4VCI {
    val name = dataItem["name"].asTstr
    val iconUrl = dataItem["iconUrl"].asTstr
    val url = dataItem["url"].asTstr
    val id0 = if (dataItem.hasKey("id")) {
        dataItem["id"].asTstr
    } else {
        null
    }
    val credentialIssuerSettings0 = if (dataItem.hasKey("credentialIssuerSettings")) {
        CredentialIssuerSettings.fromDataItem(dataItem["credentialIssuerSettings"])
    } else {
        null
    }
    return CredentialIssuerOpenID4VCI(
        name = name,
        iconUrl = iconUrl,
        url = url,
        id = id0,
        credentialIssuerSettings = credentialIssuerSettings0,
    )
}
